import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1414331e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "table table-tenant" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Tenants", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "link", -1))
const _hoisted_6 = {
  key: 0,
  style: {"height":"300px"}
}
const _hoisted_7 = { colspan: "12" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { class: "d-flex align-items-center gap-2" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 0,
  class: "badge text-bg-warning me-1"
}
const _hoisted_13 = {
  key: 1,
  class: "badge text-bg-secondary me-1"
}
const _hoisted_14 = ["href"]

import { ref, onMounted } from "vue";
import TopicService from "../services/TopicService";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import updateAppInfo from "../components/appInfo/updateAppInfo.vue";
import { TenantOptions } from "@/core/types/TenantTypes";

export default /*#__PURE__*/_defineComponent({
  __name: 'AppInfo',
  setup(__props) {

const isLoading = ref(false);
const data = ref<any[]>([]);
const updateAppInfoRef = ref(null);

const fetchData = async () => {
  isLoading.value = true;
  try {
    data.value = await TopicService.queryAppInfo();
  } catch (error) {
    console.error("Error fetching app info:", error);
  } finally {
    isLoading.value = false;
  }
};

const getImageByPlatform = (platform: string) => {
  switch (platform) {
    case "ios":
      return "/images/icons/social/soc001.svg";
    case "android":
      return "/images/icons/social/soc002.svg";
  }
};

onMounted(async () => {
  await fetchData();
});

return (_ctx: any,_cache: any) => {
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("table", _hoisted_3, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.title")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.type")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.platform")), 1),
              _hoisted_4,
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.version")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.updated_at")), 1),
              _hoisted_5,
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.action")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_7, [
                    _createVNode(ScaleLoader, { color: '#ffc730' })
                  ])
                ])
              ]))
            : (!isLoading.value && data.value.length == 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id
                    }, [
                      _createElementVNode("td", null, _toDisplayString(item.title), 1),
                      _createElementVNode("td", null, _toDisplayString(item.type), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", null, _toDisplayString(item.platform), 1),
                          _createElementVNode("img", {
                            src: getImageByPlatform(item.platform),
                            alt: ""
                          }, null, 8, _hoisted_11)
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TenantOptions), (i, index) => {
                          return (_openBlock(), _createElementBlock("span", { key: index }, [
                            (item.tenants.includes(i.value))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(i.label), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(i.label), 1))
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.version), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_TimeShow, {
                          type: "inFields",
                          "date-iso-string": item.updatedAt
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("a", {
                          href: item.downloadUrl,
                          class: "link-wrap"
                        }, _toDisplayString(item.downloadUrl), 9, _hoisted_14)
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_button, {
                          type: "success",
                          plain: "",
                          onClick: ($event: any) => (updateAppInfoRef.value.show(item))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.edit")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ]))
                  }), 128))
                ]))
        ])
      ])
    ]),
    _createVNode(updateAppInfo, {
      ref_key: "updateAppInfoRef",
      ref: updateAppInfoRef
    }, null, 512)
  ], 64))
}
}

})